import "../../../../shared/lib/store/createAppApi.js";
import "../../../../shared/lib/store/createAppAsyncThunk.js";
import { createAppSelector } from "../../../../shared/lib/store/createAppSelector.js";
import "../../../../shared/lib/store/createAppSlice.js";
import "react";
import "redux";
import "../../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../../shared/lib/store/hooks/useAppStore.js";
import { selectFilterItems } from "./selectFilterItems.js";
const selectFilterItemByKey = createAppSelector(
  [selectFilterItems, (_, { filterKey }) => filterKey],
  (filterItems, filterKey) => {
    const filterItem = filterItems.find((item) => item.key === filterKey);
    return filterItem;
  }
);
export {
  selectFilterItemByKey
};
